



















































































































































import Profile from './views/Services/Profile.vue';
export default {
	components: {
		Profile,
	},
	name: 'Main',
	data() {
		return {
			isCollapsed: true,
			loadingData: true,
			loadingText: this.$t('common.loading'),
			profile: false,
			alreadyCalled: false,
		};
	},
	computed: {
		user(): Object {
			return this.$store.state.user;
		},
		expired(): Boolean {
			return this.$store.getters.isExpired;
		},
		unMigrated(): Boolean {
			return !!this.$store.getters.unMigrated;
		},
		organization(): Object {
			return this.$store.state.organization;
		},
		trialing(): Boolean {
			return this.$store.state.organization.license && this.$store.state.organization.license.status === 'trialing';
		},
		trialEnds(): String {
			return this.$store.state.organization.license
				? this.$moment(this.$firebase.firestore.FieldValue.serverTimestamp()).to(
						this.$store.state.organization.license.expiry.toDate()
				  )
				: '';
		},
		users(): Boolean {
			return this.$store.state.users;
		},
	},
	watch: {
		users(newValue, oldValue): void {
			if (newValue === oldValue) return;
			if (this.timeout) clearTimeout(this.timeout);
			this.timeout = setTimeout(() => {
				if (!newValue || newValue.length === 0) return;
				const thisUser = newValue.find(el => el.email === this.user.email);
				if (!thisUser || !thisUser.admin) this.logout();
				this.$store.dispatch('getMetrics');
			}, 100);
		},
		unMigrated(newValue, oldValue): void {
			newValue !== oldValue && newValue && this.updateWorkspace();
		},
	},
	methods: {
		showMenu(): void {
			this.isCollapsed = !this.isCollapsed;
		},
		showWidget(): void {
			// @ts-ignore-next-line
			window.FreshworksWidget('identify', 'ticketForm', {
				name: this.user.displayName,
				email: this.user.email,
			});
			// @ts-ignore-next-line
			window.FreshworksWidget('prefill', 'ticketForm', {
				type: 'Enterprise',
				priority: 4, // Urgent
				status: 2, // Open
			});
			// @ts-ignore-next-line
			window.FreshworksWidget('open');
		},
		downloadInstaller(): void {
			window.open('https://github.com/ramboxapp/download/releases/latest');
		},
		handleCommand(command: string): void {
			switch (command) {
				case 'logout':
					this.logout();
					break;
				case 'profile':
					this.profile = true;
					break;
				case 'billing':
					this.customerPortal();
					break;
			}
		},
		async logout(): Promise<void> {
			try {
				const success = await this.$store.dispatch('logout');
			} catch (error) {
				console.log('Error: ' + error);
			}
		},
		async customerPortal(): Promise<void> {
			try {
				let popup = window.open('', '_blank');
				popup && popup.document.write(this.$t('main.loadingBillingPortal'));

				const response = await this.$firebase.functions().httpsCallable('stripeCustomerPortal')({
					customer: this.organization.stripe.id,
				});
				popup && (popup.location.href = response.data.session.url);
			} catch (error) {
				console.error(error);
				this.$message({
					type: 'error',
					message: this.$translateError(error),
				});
			}
		},
		async updateWorkspace(): Promise<void> {
			// Prevent unnecessary and wronfully updating the workspace (all workspaces are updated at this moment, so it's not necessary to update it again)
			this.$message({
				type: 'error',
				message: this.$t('main.workspaceError'),
			});
			this.logout();
		},
	},
	async mounted() {
		// @ts-ignore-next-line
		window.FreshworksWidget('hide', 'launcher');

		this.loadingText = this.$t('main.loadingPleaseWait');
		await this.$store.dispatch('getOrganization');
		// this.loadingText = 'Validating License...';
		await this.$store.dispatch('validateLicense');
		this.unMigrated && (await this.updateWorkspace());
		await this.$store.dispatch('loadConfigs');
		this.loadingData = false;
		// this.loadingText = 'Loading Teams...';
		await this.$store.dispatch('loadDepartments');
		// this.loadingText = 'Loading Users...';
		await this.$store.dispatch('loadUsers');
	},
};
